<template>
	<div>		
		<Dialog v-model:visible="displayModalAddRefillPoint" :style="{width: '30vw'}" :modal="true" :header="translated('newrefillptitle')" class="globalDialog">
            <div class="card fluid">       
                <div class="field grid">
                    <label for="name1" class="col-12 md:col-3 mb-md-0">{{ translated('fueltable') }}</label>
                    <div class="col-12 md:col-8">
                        <Dropdown v-model="tmpFuel" :options="FuelAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectfueltype')" />					
                    </div>                        
                </div>	
                <div class="field grid">
                    <label for="name1" class="col-12 md:col-3 mb-md-0">{{ translated('companyname') }}</label>
                    <div class="col-12 md:col-8">
                        <InputText id="name1" type="text" v-model="tmpName" />							
                    </div>                        
                </div>		
                <div class="field grid">
                    <label for="newevseid" class="col-12 md:col-3 mb-md-0">{{ translated('evseid') }}</label>
                    <div class="col-12 md:col-8">
                        <InputText id="newevseid" type="text" v-model="tmpEvseid" />							
                    </div>  						
                </div>	               												
            </div>
			<template #footer>
				<Button label="Close" icon="pi pi-times" @click="closeModal" class="p-button-text"/>
				<Button label="Add" icon="pi pi-check" @click="closeAddRefillPoint" autofocus />
			</template>
		</Dialog>
	</div>

    <div class="grid">
        <div class="col-12">
            <div class="card fluid oneStation">
                <div class="field grid"> 
                    <div class="col-10">
                        <h5 class="addr1">{{ translated('statiotitle') }} </h5><h5 class="addr2">{{Station.Name}}</h5>
                    </div>
                    <div class="col-2">
                        <Button v-if="!isMinisterstvo" :label="translated('removestationbutton')" class="p-button-raised p-button-warning removestation" icon="pi pi-trash" @click="removeElement" />
                    </div>
                    
                    
                </div>
                
                <div class="stationClass" v-if="Station">
                    <div class="field grid"> 
                        <div class="col-6">
                            <div class="field grid">
                                <label class="col-12 p-mb-4 md:col-5 mb-md-0" :class="{'p-error': v$.Station.Name.$invalid && submitted}">{{ translated('companyname') }} *</label>
                                <div class="col-12 md:col-7">
                                    <InputText :disabled="isMinisterstvo" type="text" v-model="Station.Name" :class="{'p-invalid':v$.Station.Name.$invalid && submitted}"/>
                                </div>                        
                            </div>   

                            <div class="field grid">
                                <label class="col-12 p-mb-4 md:col-5 mb-md-0" :class="{'p-error': v$.Station.EnergyInfrastructureStationIndex.$invalid && submitted}">{{ translated('stationindex') }} *</label>
                                <div class="col-12 md:col-7">
                                    <InputNumber :disabled="isMinisterstvo" v-model="Station.EnergyInfrastructureStationIndex" :class="{'p-invalid':v$.Station.EnergyInfrastructureStationIndex.$invalid && submitted}" />
                                </div>                        
                            </div> 

                            <div class="field grid">
                                <label class="col-12 p-mb-4 md:col-5 mb-md-0">{{ translated('evseid') }}</label>
                                <div class="col-12 md:col-7">
                                    <InputText :disabled="isMinisterstvo" ctype="text" v-model="Station.EvseId" />
                                </div>                        
                            </div> 

                            <div class="field grid">
                                <label class="col-12 p-mb-4 md:col-5 mb-md-0">{{ translated('authshort') }}</label>
                                <div class="col-12 md:col-7">
                                    <Dropdown :disabled="isMinisterstvo" v-model="Station.AuthenticationAndIdentificationMethod" :options="AuthenticationAndIdentificationAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectauthtype')" />								
                                </div>  						
                            </div>

                            <div class="field grid">
                                <label class="col-12 p-mb-4 md:col-5 mb-md-0">{{ translated('paymenttypes') }}</label>
                                <div class="col-12 md:col-7">
                                    <MultiSelect :disabled="isMinisterstvo" v-model="Station.PaymentTypes" :options="PaymentTypesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectpaymenttype')" />	
                                </div>                        
                            </div>	

                            <div class="field grid">
                                <label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('contractproviders') }}</label>
                                <div class="col-12 md:col-7">
                                    <!-- <InputText :disabled="isMinisterstvo" type="text" v-model="Station.ContractProviders" /> -->
                                    <Textarea :disabled="isMinisterstvo" class="textareCProviders" v-model="Station.ContractProviders" autoResize="false" rows="4" maxlength="500" />
                                </div>                        
                            </div>	


                            <div class="field grid" v-if="electricExists">
                                <label for="evseid" class="col-12 md:col-5 mb-md-0">{{ translated('maxpower') }}</label>
                                <div class="col-12 md:col-7">
                                    <InputNumber :disabled="isMinisterstvo" v-model="electricMaxPower" :minFractionDigits="2" locale="sl-SI" />
                                </div>                        
                            </div>	


                            <div class="field grid">
                                <label class="col-12 p-mb-4 md:col-5 mb-md-0">{{ translated('externalsystemid') }}</label>
                                <div class="col-12 md:col-7">
                                    <InputText class="btneditenabledExternalId" type="text" v-model="Station.ExternalSystemId" :disabled="!editenabledExternalId" />
                                    <Button v-if="editenabledExternalId && !isMinisterstvo" icon="pi pi-lock-open" class="p-button-rounded p-button-warning editenabledExternalId" @click="editenabledExternalId=false" />
                                    <Button v-if="!editenabledExternalId && !isMinisterstvo" icon="pi pi-lock" class="p-button-rounded p-button-warning editenabledExternalId" @click="editenabledExternalId=true" />
                                </div>                        
                            </div> 
                        </div>  

                        <div class="col-6">
                            <div class="field grid">
                                <span class="p-float-label col-12">                                    
                                    <Textarea :disabled="isMinisterstvo" class="textareanotes" v-model="Station.Notes" :autoResize="false" rows="13" />
                                    <label class="noteslabel">{{ translated('notes') }}</label>
                                </span>        
                     
                            </div>                        
                        </div>  

                    </div>




                                       

                    <!--   
                    <div class="field grid">
                        <label for="name3" class="col-12 p-mb-2 md:col-2 mb-md-0">Cars</label>
                        <div class="col-12 md:col-10">
                            <InputText id="name34" type="text" />
                        </div>
                    </div> 
                                                
                    <div class="field grid">
                        <label for="name3" class="col-12 p-mb-2 md:col-2 mb-md-0">Cars</label>
                        <div class="col-12 md:col-10">
                            <MultiSelect v-model="selectedCars" :options="cars" optionLabel="brand" placeholder="Select Brands" @change="IzbralSemNekaj" />
                        </div>
                    </div>    
                    -->
                                            

                </div> 


                <div class="field grid card allrefillpoints"> 
                    <div class="col-12 headerrefillpoints">
                        <h5>{{ translated('refillpointstitle') }}</h5>
                        <Button v-if="!isMinisterstvo" :label="translated('addrefillpointbutton')" icon="pi pi-plus" class="p-button-sm addnewrefillpoint" @click="openModalAddRefillPoint" />														
                    </div>         

                    <div class="grid col-12 placeforrefillpoints">
                        <div v-for="refillpointx in Station.RefillPoints" :key="refillpointx.CreatedDate" :class="refillpointx.Fuel!='Electric' ? 'col-6' : 'col-12'">
                            <div class="oneRefillPointPlaceholder card">
                                <RefillPoint :RefillPoint="refillpointx" :FinancedAllOptions="FinancedAllOptions" :submitted="submitted" :key="refillpointx.CreatedDate" @removeRefillPoint="removeRefillPointElementEvent" /> 
                            </div>                            
                        </div>
                    </div>

                </div>
                                          
            </div>
        </div>     
    </div>

</template>

<script>
import { email, required, between, numeric, minLength, maxLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import RefillPoint from '@/components/RefillPoint.vue'
import { computed } from "vue";
import store from "@/store";

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: { RefillPoint },
    emits: ["removeStation"],
    props: ['Station','PaymentTypesAllOptions', 'FinancedAllOptions', 'submitted'],
    data() {
        return {
            editenabledExternalId: false,
            translated: computed(() => store.getters.getTranslate),
            displayModalAddRefillPoint: false,
            tmpName: "",
            tmpEvseid: "",
            tmpFuel: "",
            FuelAllOptions: [
                {label: "Electric", value: "Electric"},
                {label: "Hydrogen", value: "Hydrogen"},
                {label: "OrganicGas", value: "OrganicGas"}
            ],
            AuthenticationAndIdentificationAllOptions: [
                {label: "activeRFIDChip", value: "activeRFIDChip"},
                {label: "apps", value: "apps"},
                {label: "calypso", value: "calypso"},
                {label: "cashPayment", value: "cashPayment"},
                {label: "creditCard", value: "creditCard"},
                {label: "debitCard", value: "debitCard"},
                {label: "mifareClassic", value: "mifareClassic"},
                {label: "mifareDesfire", value: "mifareDesfire"},
                {label: "nfc", value: "nfc"},
                {label: "overTheAir", value: "overTheAir"},
                {label: "phoneDialog", value: "phoneDialog"},
                {label: "phoneSMS", value: "phoneSMS"},
                {label: "pinpad", value: "pinpad"},
                {label: "plc", value: "plc"},
                {label: "prepaidCard", value: "prepaidCard"},
                {label: "rfid", value: "rfid"},
                {label: "website", value: "website"},
                {label: "unlimitedAccess", value: "unlimitedAccess"}   ,
                {label: "noAccess", value: "noAccess"}            
            ]        
        }
    },
    validations() {
        let myvalidations = {
            Station: {
				Name: { required },
                EnergyInfrastructureStationIndex: { required }    
			} 
        };
        return myvalidations;
    },	    
    created() {
        //console.log('KLIČEM CREATED!!!!')
    },
    mounted() {

        // console.log('KLIČEM MOUNTED!!!!')
        // console.log(this.Station);
        // console.log(this.PaymentTypesAllOptions);
        // console.log(this.FinancedAllOptions);

    },
    computed: {
		isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
            //return (this.$store.getters.getRole=="MAdmin" || this.$store.getters.getRole=="MUser");
			//return true;
        },
        electricExists() {
			return (this.Station.RefillPoints && this.Station.RefillPoints.some(refill => refill.Fuel === 'Electric'));        
        },    
		electricMaxPower: {
			get() {
				return (this.Station.MaxPower / 1000).toFixed(2);
			},
			set(value) {
				this.Station.MaxPower = parseFloat(value) * 1000;
			}
		}
    },   
    methods: {
        openModalAddRefillPoint() { 
            this.tmpName=""
            this.tmpEvseid=""
           // console.log('kliknil add refill point')
            this.displayModalAddRefillPoint = true
        },        
        
        closeModal() {
            this.displayModalAddRefillPoint = false
        },
        closeAddRefillPoint() {
            //console.log('Fuel:');
            //console.log(this.tmpFuel);
            this.displayModalAddRefillPoint = false
            if(!this.Station.RefillPoints) {
                //console.log('nimam kolekcije, kreiram');
                this.Station.RefillPoints = new Array()
            }
            this.Station.RefillPoints.push({Fuel: this.tmpFuel, Name: this.tmpName, CreatedDate: 'D-' + Date.now(), EvseId: this.tmpEvseid})
        },
        removeElement() {
            //console.log('kliknil remove znotraj komponente')
            this.$emit('removeStation', {id: this.Station.Id, CreatedDate: this.Station.CreatedDate})            
        },
        removeRefillPointElementEvent(parametri) {
            /*
            console.log('kliknil remove')
            console.log(parametri)
*/
            const arr = this.Station.RefillPoints.filter(function(item) {
                if(parametri.id)
                    return item.Id !== parametri.id
                else
                    return item.CreatedDate !== parametri.CreatedDate
            })

            this.Station.RefillPoints = arr            
        }        
    }    

}
</script>

<style scoped lang="scss">
.textareanotes {
    height: 230px;
}

.grid.placeforrefillpoints {
    margin-top: 20px;
}

.oneRefillPoint {
    margin: 5px;
}

button.removestation {
    width: auto;
    position: relative;
    float: right;
}

.col-12.headerrefillpoints {
    border-bottom: 1px dashed #e9ecef;
    height: 35px;
}

.field.grid.card.allrefillpoints {
    background: #ced4da;
}

button.p-button.addnewrefillpoint {
    width: auto;
    position:relative;
    float:right;    
}

.headerrefillpoints H5 {
    width: 60%;
    position:relative;
    float:left;
}

textarea.textareanotes {
    font-size: 0.9rem;
}

label.noteslabel {
    margin-left: 5px;
}

.addStation {
    position: relative;
    float: right;
    top: -40px;
}

.stationClass {
    margin-top:40px;
}

.oneStation {
    background: #e9ecef;
}

h5.addr1, h5.addr2 {
    width: auto;
    position: relative;
    float: left;
    margin-top: 0;
    padding:5px
}

h5.addr2 {
    margin-left:5px;
    border-bottom:1px solid black
}

h5.addr1 {
    background:#a6d5fac9;
    border-radius: 3px;
}

input.btneditenabledExternalId {
	width: calc( 100% - 50px );
}

button.editenabledExternalId {
	margin-left: 10px;
}

</style>